module.exports = __webpack_public_path__ + "img/bri.82b587f1.svg";